/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'location': {
    width: 128,
    height: 128,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M511.932 0c-213.944 0-387.88 170.934-387.88 381.062 0 164.815 238.87 485.1 341.664 620.248a58.25 58.25 0 0046.216 22.69c18.13 0 35.492-8.444 46.33-22.69C660.965 866.184 899.97 545.877 899.97 381.062 899.97 170.934 725.899 0 511.932 0zm0 519.575c-91.393 0-165.786-72.903-165.786-162.67 0-89.724 74.393-162.739 165.786-162.739 91.439 0 165.719 73.015 165.719 162.738 0 89.768-74.28 162.67-165.719 162.67z" _fill="#f07441"/>'
  }
})
